module.exports = __webpack_public_path__ + "img/number-three.5d64cc2e.png";